import FbCallback from "./FbCallback";
export default FbCallback;
